import { create } from 'zustand'

export const useUIStore = create((set) => ({
  isLoading: true,

  setLoading: (updater) =>
    set((state) => ({
      isLoading: typeof updater === 'function' ? updater(state.isLoading) : updater,
    })),
}))
